import React, { useRef } from 'react'
import email from '../../assets/image/email.avif'
import git from '../../assets/image/github.avif'
import linkedin from '../../assets/image/linkedin.avif'
import insta from '../../assets/image/insta.avif'
//import indeed from '../../assets/image/indeed.avif'
import raddit from '../../assets/image/raddit.avif'

import { useGSAP } from '@gsap/react';   // 👈 Add GSAP imports
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin once
gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
// const [hoveredButton, setHoveredButton] = useState(null);

// const handleMouseEnter = (id) => {
//     setHoveredButton(id);
// };

// const handleMouseLeave = () => {
//     setHoveredButton(null);
// };

// --- GSAP Animation Refs ---
const footerRef = useRef(null);
const logoRef = useRef(null);
const ctaRef = useRef(null);

// footer gsap code starts
useGSAP(() => {
    const footerTl = gsap.timeline({
        scrollTrigger: {
            trigger: footerRef.current,
            start: 'top 80%', // Start the animation when 85% of the footer is visible
            toggleActions: 'play none none reverse',
        },
        defaults: { ease: 'power2.out', duration: 1.2 }
    });

    // 1. Simultaneous Entrance (CTA and Logo)
    // Animate the CTA text from the left
    footerTl.from(ctaRef.current, {
        x: -100,
        opacity: 0,
    }, "start"); // Add a label "start"

    // Animate the Logo/Name from the right
    footerTl.from(logoRef.current, {
        x: 100,
        filter: "blur(8px)",
        opacity: 0,
    }, "start"); // Start at the same time as CTA

    // Animate the "CONTACT" text (y-slide)
    footerTl.from('.contact-label', {
        y: 20,
        opacity: 0,
        duration: 0.5,
    }, "-=0.6"); // Overlap slightly with the main pincer move

    // 2. Contact Buttons Stagger
    // This targets ALL elements whose class name ends with '-cont' (e.g., email-cont, git-cont)
    gsap.from('.contact-link', {
        opacity: 0,
        filter: "blur(4px)",
        y: 20,
        // duration: 0.5,
        ease: "power2.in",
        stagger: 0.125,  // Stagger delay between each button
        scrollTrigger: {
            // trigger: footerRef.current, // Trigger the group when the footer comes into view
            trigger: ".contact-label",
            start: 'top 80%', // Start closer to the bottom to reveal the buttons last
            toggleActions: 'play none none reverse',
        }
    }, "-=0.3");

}, { scope: footerRef });

return (
    <>
        <footer ref={footerRef} id='contact' className="lg:px-20 xl:px-32 text-center text-surface lg:text-left dark:text-tx-col">
            <div className="container sm:p-6 mx-auto">
                <div className="mt-6 md:mt-0 grid gap-4 lg:grid-cols-2 items-center">
                    <div className="md:mb-0 lg:order-last text-center lg:text-end">
                        <h2 ref={logoRef} className="font-andika text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl"><span className='text-y-col'>&lt;</span>Darshik<span className='text-y-col'>/&gt;</span></h2>
                    </div>

                    <div className="mb-6 md:mb-0">
                        <p ref={ctaRef} className="font-pockota mb-2 font-semibold lg:font-bold text-xl sm:text-2xl md:text-4xl">Let's craft an experience <span className='text-b-col'>together</span>.</p>

                        <div className="mx-auto lg:mx-0 mb-2">
                            <p className="contact-label mb-4 text-base sm:text-lg md:text-xl font-semibold">
                                CONTACT
                            </p>
                            <div className="icons flex flex-col gap-5 items-center lg:items-start mb-4">
                                <a
                                    href='mailto:rajparadarshi@gmail.com?subject=Hello%20Darshik!'
                                    target='_blank'
                                    rel="noreferrer"
                                    type='button'
                                    className='contact-link min-w-[200px] bg-[#ea4335] rounded-md px-10 py-2 font-semibold text-black hover:text-white hover:pe-[70px] flex justify-center items-center gap-2 overflow-hidden relative'
                                >
                                    <span className='z-[2] email-cont'></span>
                                    <img className='h-6 email absolute z-[1] pointer-events-none' src={email} alt="Email Icon" />
                                </a>
                                <a
                                    href='https://github.com/DarshikR'
                                    target='_blank'
                                    rel="noreferrer"
                                    type='button'
                                    className='contact-link min-w-[200px] bg-[#171515] rounded-md px-10 py-2 font-semibold text-black hover:text-white hover:pe-[70px] flex justify-center items-center gap-2 overflow-hidden relative'
                                >
                                    <span className='z-[2] git-cont'></span>
                                    <img className='h-6 git absolute z-[1] pointer-events-none' src={git} alt="GitHub Icon" />
                                </a>
                                <a
                                    href='https://www.linkedin.com/in/darshik-r-28956427a/'
                                    target='_blank'
                                    rel="noreferrer"
                                    type='button'
                                    className='contact-link min-w-[200px] bg-[#0a66c2] rounded-md px-10 py-2 font-semibold text-black hover:text-white hover:pe-[70px] flex justify-center items-center gap-2 overflow-hidden relative'
                                >
                                    <span className='z-[2] linkedin-cont'></span>
                                    <img className='h-6 linkedin absolute z-[1] pointer-events-none' src={linkedin} alt="LinkedIn Icon" />
                                </a>
                                <a
                                    href='https://www.instagram.com/darshikrajpara/'
                                    target='_blank'
                                    rel="noreferrer"
                                    type='button'
                                    className='contact-link min-w-[200px] bg-gradient-to-b from-[#713E9D] to-[#A0338C] rounded-md px-10 py-2 font-semibold text-black hover:text-white hover:pe-[70px] flex justify-center items-center gap-2 overflow-hidden relative'
                                >
                                    <span className='z-[2] insta-cont'></span>
                                    <img className='h-6 insta absolute z-[1] pointer-events-none' src={insta} alt="Instagram Icon" />
                                </a>
                                <a
                                    href='https://www.reddit.com/user/Darshik25/'
                                    target='_blank'
                                    rel="noreferrer"
                                    type='button'
                                    className='contact-link min-w-[200px] bg-gradient-to-b bg-[#FF4500] rounded-md px-10 py-2 font-semibold text-black hover:text-white hover:pe-[70px] flex justify-center items-center gap-2 overflow-hidden relative'
                                >
                                    <span className='z-[2] raddit-cont'></span>
                                    <img className='h-8 raddit absolute z-[1] pointer-events-none' src={raddit} alt="Raddit Icon" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <p className="contact-label my-4 text-sm">
                    Portfolio built by
                    <a className='mx-1 hover:underline text-y-col' target='_self' href="https://www.linkedin.com/in/darshik-r-28956427a">Darshik Rajpara</a>
                    — visually inspired by
                    <a className='ms-1 hover:underline text-y-col' target='_blank' rel="noreferrer" href="https://www.behance.net/ritikyaduvanshii">Ritik Yadav</a>’s Behance design.
                </p>
            </div>
        </footer>
    </>
)
}

export default Footer;
